import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';
import _ from 'lodash';
import { faStarShooting } from '@fortawesome/pro-light-svg-icons';

import SmallProviderCard from 'components/SmallProviderCard';
import Card from './Card';
import * as track from 'lib/track';



const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 20px;
  width: 100%;
`;

const RelatedProviders = ({ data, isLoading }) => {

  return (
    <Card title="Related Trusted Providers" icon={faStarShooting} isLoading={isLoading} noData={_.isEmpty(data)}>
      <Container>
        {data.map((item, index) => (
          <SmallProviderCard
            key={index}
            title={item.name}
            uuid={item.uuid}
            url={item.url}
            imagePath={item.imagePath}
            rating={item.rating}
            reviewCount={item.reviewCount}
            hideBadge
            flex
            eventTrackerName={track.RELATED_PROVIDER_CLICK}
          />
        ))}
      </Container>
    </Card>
  );
};

RelatedProviders.propTypes = {
  data: PropTypes.array,
  isLoading: PropTypes.bool,
};


export default RelatedProviders;

